import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonEnterGreyedCatchRide = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 12,
	viewBox: "0 0 28 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M5.19615 1L10.3923 10L0 10L5.19615 1Z",
			fill: "#9E9E9E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5335 11H17.2478V3.85L21.2478 0L21.9621 0.6875C22.0287 0.751667 22.0836 0.83875 22.1266 0.94875C22.1697 1.05875 22.191 1.16417 22.1906 1.265V1.4575L21.5621 3.85H25.2478C25.5525 3.85 25.8192 3.96 26.0478 4.18C26.2763 4.4 26.3906 4.65667 26.3906 4.95V6.05C26.3906 6.11417 26.3811 6.18292 26.3621 6.25625C26.343 6.32958 26.324 6.39833 26.3049 6.4625L24.5906 10.34C24.5049 10.5233 24.3621 10.6792 24.1621 10.8075C23.9621 10.9358 23.7525 11 23.5335 11ZM18.3906 9.9H23.5335L25.2478 6.05V4.95H20.1049L20.8763 1.925L18.3906 4.3175V9.9ZM17.2478 3.85V4.95H15.5335V9.9H17.2478V11H14.3906V3.85H17.2478Z",
			fill: "#9E9E9E"
		})
	]
});
const ForwardRef = forwardRef(SvgPersonEnterGreyedCatchRide);
export { ForwardRef as ReactComponent };
